const loginForm = document.querySelector('.customer__wrapper');
const forgotButton = loginForm.querySelector('[data-forgot-password]');
const cancelButton = loginForm.querySelector('[data-cancel]');
const signInForm = loginForm.querySelector('.login__form--login');
const forgotForm = loginForm.querySelector('.login__form--forgot');

const toggleForms = (form, alternateForm) => {
	form.classList.remove('fade-in');
	form.classList.add('fade-out');
	setTimeout(() => {
		alternateForm.classList.add('fade-in');
		alternateForm.classList.remove('fade-out');
	}, 200)
}

forgotButton.addEventListener('click', () => {
	toggleForms(signInForm, forgotForm)
});

cancelButton.addEventListener('click', () => {
	toggleForms(forgotForm, signInForm)
});